import { combineReducers } from "@reduxjs/toolkit";
import users from "./users";
import job from "./job";
import quotation from "./quotation";
import assignLocation from "./subUser";
import jobType from "./jobType";
import customerQuotation from "./customerQuotation";
import customer from "./customer";

export const reducers = combineReducers({
  users,
  jobType,
  job,
  quotation,
  assignLocation,
  customerQuotation,
  customer,
});
